'use strict';

module.exports = function() {
  return /\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b/;
};



//////////////////
// WEBPACK FOOTER
// ./~/domain-regex/index.js
// module id = 758
// module chunks = 15